import './App.css';
import Sidebar from './components/Sidebar';
import Chat from './components/Chat';
import {Routes,Route,Link,BrowserRouter,useNavigate, matchPath} from 'react-router-dom';
import Loginpage from './components/Loginpage';
import {useState,useEffect} from 'react';
import {getAuth,signInWithPopup,GoogleAuthProvider} from "firebase/auth";
import {provider,auth} from './components/Firebase';
import { setUserLog,setUserOut} from './components/userSlice';
import {getname,getemail,getphoto} from './components/userSlice';
import {useSelector,useDispatch} from 'react-redux';
import MoreInfo from './components/MoreInfo';
import styled from 'styled-components';
function App() {

  const name=useSelector(getname);
  const email=useSelector(getemail);
  const photo=useSelector(getphoto);
  const dispatch=useDispatch();

var[width,setwidth]=useState(window.screen.width);

  var [User,setUser]=useState(false);

  
  useEffect(()=>{auth.onAuthStateChanged(async (user)=>{
    if(user){dispatch(setUserLog({name:user.displayName,email:user.email,
        photo:user.photoURL
        
        }))
    
    setUser(true);
    }
    else{setUser(false);}

})




},[]);

setInterval(()=>{setwidth(window.screen.width)},200);


  return  <>{User ? (<div className="app">
  
    <div className='app_body'>

    

      <BrowserRouter>
{width>819 ? <Sidebar/>:<Routes><Route path="/" element={<Sidebar/>}/></Routes>}
      <Routes>
      
<Route path='/rooms/:roomId' element={<Chat/>}/>
<Route path="/groups/:groupId" element={<MoreInfo/>}/>
      </Routes>
      </BrowserRouter>


    </div>
    </div>) :  <BrowserRouter>
    <Loginpage/>
      </BrowserRouter> 
  }
<Footer><p><b>website developed by Saikat Sen - No Commertial purposes intended,made only for showing web developement techniques and
  to be included as a piece of portfolio.All copyrights are owned by WhatsApp</b></p></Footer>
</>

}

export default App;

const Footer=styled.div`
p{color:black;text-align:center;margin-bottom:10px;
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
@media (max-width:500px) {
  font-size:7px;
}
}
`
